import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets the global app configuration.
   * @returns {Promise<{appConfig: {sessionTimeOut: Number, paymentTimeOut: Number, refiPaymentTimeOut: Number, restrictedStateCheck: Boolean, logNonFatalErrors: Boolean, manageNotifications: Boolean, skipSsnCheck: Boolean, displayTermsConditionsConsent: Boolean, trustedDeviceSettings: {enabled: Boolean}, stickyHeaderId: String, instaHeaderId: String, instaSidebarId: String, allowNlsMlaCheck: Boolean, allowNoSsnRefi: Boolean, menuItemVisibility: Object, loanDocumentUploadSettings: Object, pastDuePhoneDayLimit: Object, ecommProdSwitchConfirmPage: String, canUploadNlsLoanDocuments: boolean, canUploadTlxeLoanDocuments: boolean, disbursementMaxPollingAttempts: Number, canUseDisbursementPolling: Boolean, forceAddonGps: Boolean, forceRefiGps: Boolean, canSendVoiceMessages: Boolean, manualRetryConfig {enabled: Boolean, intervalInMinutes: Number}}}>}
   */
  async getConfigSettings () {
    Logger.info('Started Get Config Settings query')
    return tmxApiCall('get', '/configsettings')
  },

  async getLmsReferenceIds () {
    Logger.info('Started Get LMS Reference Id query.')
    return tmxApiCall('get', '/lmsReferenceId')
  },

  async getContactUs () {
    Logger.info('Started Get Contact Us query.')
    return tmxApiCall('get', '/contacts')
  },

  /**
   * Gets the global service availability
   * @returns {Promise<{available: Boolean}>}
   */
  async getServiceStatus () {
    Logger.info('Started Get Service Status')
    return tmxApiCall('get', '/serviceStatus')
  }
}
